import React, { useState } from 'react';

function MenuPreview({ config }) {
  const [messages, setMessages] = useState([]);
  const [step, setStep] = useState('idle'); // idle, main_menu, submenu:{key}, awaiting_details, completed
  const [currentOptions, setCurrentOptions] = useState(null);
  const [, setParentOption] = useState(null);

  const addMessage = (sender, text) => {
    setMessages((prev) => [...prev, { sender, text, time: new Date().toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' }) }]);
  };

  const formatOptions = (options) => {
    return options.map((o) => `${o.key}️⃣ ${o.label}`).join('\n');
  };

  const start = () => {
    setMessages([]);
    setStep('idle');
    setCurrentOptions(null);
    setParentOption(null);
    // Simulate customer sending hi
    setTimeout(() => {
      addMessage('customer', 'السلام عليكم');
      setTimeout(() => {
        const menuText = `${config.welcomeMessage}\n\n${formatOptions(config.options)}\n\nأرسل رقم الخيار 👇`;
        addMessage('bot', menuText);
        setStep('main_menu');
        setCurrentOptions(config.options);
      }, 500);
    }, 300);
  };

  const selectOption = (option) => {
    addMessage('customer', option.key);

    setTimeout(() => {
      if (option.type === 'handoff') {
        addMessage('bot', option.autoReply);
        setStep('completed');
        setCurrentOptions(null);
        return;
      }

      if (option.type === 'submenu' && option.submenu && option.submenu.length > 0) {
        const subText = `${option.autoReply}\n\n${formatOptions(option.submenu)}\n\n0️⃣ رجوع للقائمة الرئيسية`;
        addMessage('bot', subText);
        setStep(`submenu:${option.key}`);
        setCurrentOptions(option.submenu);
        setParentOption(option);
        return;
      }

      if (option.type === 'reply') {
        if (option.detailsPrompt) {
          addMessage('bot', `${option.label} — ممتاز! 👍\n\n${option.detailsPrompt}`);
          setStep('awaiting_details');
          setCurrentOptions(null);
        } else if (option.autoReply) {
          addMessage('bot', option.autoReply);
          setStep('awaiting_details');
          setCurrentOptions(null);
        } else {
          addMessage('bot', `تم تسجيل طلبك. سيتواصل معك فريقنا قريباً. 📞`);
          setStep('completed');
          setCurrentOptions(null);
        }
      }
    }, 500);
  };

  const simulateDetails = () => {
    addMessage('customer', 'V-Belt SPB 1800 × 10 Optibelt');
    setTimeout(() => {
      addMessage('bot', `تم استلام طلبك! ✅\n\n📋 ملخص:\n• التفاصيل: V-Belt SPB 1800 × 10 Optibelt\n• رقم الطلب: #QR-0000\n\nسيتواصل معك فريق المبيعات خلال ساعة.\n📞 أو اتصل مباشرة: 0538339982`);
      setStep('completed');
    }, 500);
  };

  const goBack = () => {
    addMessage('customer', '0');
    setTimeout(() => {
      const menuText = `${config.welcomeMessage}\n\n${formatOptions(config.options)}\n\nأرسل رقم الخيار 👇`;
      addMessage('bot', menuText);
      setStep('main_menu');
      setCurrentOptions(config.options);
      setParentOption(null);
    }, 500);
  };

  if (!config) {
    return <div className="sd-preview-empty">لا يوجد تكوين للمعاينة</div>;
  }

  return (
    <div className="sd-preview">
      {/* Phone Frame */}
      <div className="sd-preview-phone">
        {/* Phone Header */}
        <div className="sd-preview-phone-header">
          <span className="sd-preview-phone-name">معرض السيور</span>
          <span className="sd-preview-phone-status">متصل</span>
        </div>

        {/* Messages Area */}
        <div className="sd-preview-messages">
          {messages.length === 0 && (
            <div className="sd-preview-start-hint">
              اضغط "ابدأ المحادثة" لمشاهدة المعاينة
            </div>
          )}
          {messages.map((msg, i) => (
            <div key={i} className={`sd-preview-msg sd-preview-msg-${msg.sender}`}>
              <div className="sd-preview-msg-bubble">
                <span className="sd-preview-msg-text">{msg.text}</span>
                <span className="sd-preview-msg-time">{msg.time}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="sd-preview-actions">
          {step === 'idle' && (
            <button className="sd-preview-start-btn" onClick={start}>
              ▶ ابدأ المحادثة
            </button>
          )}

          {step === 'main_menu' && currentOptions && (
            <div className="sd-preview-options">
              {currentOptions.map((opt) => (
                <button key={opt.key} className="sd-preview-option-btn" onClick={() => selectOption(opt)}>
                  {opt.key}️⃣ {opt.label}
                </button>
              ))}
            </div>
          )}

          {step.startsWith('submenu:') && currentOptions && (
            <div className="sd-preview-options">
              {currentOptions.map((opt) => (
                <button key={opt.key} className="sd-preview-option-btn" onClick={() => selectOption(opt)}>
                  {opt.key}️⃣ {opt.label}
                </button>
              ))}
              <button className="sd-preview-back-btn" onClick={goBack}>0️⃣ رجوع</button>
            </div>
          )}

          {step === 'awaiting_details' && (
            <button className="sd-preview-option-btn" onClick={simulateDetails}>
              📝 إرسال تفاصيل (محاكاة)
            </button>
          )}

          {step === 'completed' && (
            <div className="sd-preview-completed">
              <span>✅ انتهت المحادثة — الموظف يتولى من هنا</span>
              <button className="sd-preview-restart-btn" onClick={start}>🔄 إعادة</button>
            </div>
          )}
        </div>
      </div>

      {/* Instructions */}
      <div className="sd-preview-info">
        <p>هذه معاينة تفاعلية — اضغط على الخيارات لمشاهدة كيف يرى العميل القائمة.</p>
        <p>التغييرات تظهر فوراً بدون حفظ — لتطبيقها على واتساب اضغط "حفظ" أعلاه.</p>
      </div>
    </div>
  );
}

export default MenuPreview;
